import {GetBasketRecommendationsResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/basket/v1/recommendations/service.types';
import {useTranslation} from '@aboutyou/i18n';
import {useTrackFeature} from '@aboutyou/tracking';
import {COLORS, HorizontalSlider, Text} from '@aboutyou/ui-components';
import React, {useEffect} from 'react';
import styled from 'styled-components';
import {ProductTile} from '../../ProductTile/ProductTile';

export const AddToBasketSuccessRecosView: React.FC<
  GetBasketRecommendationsResponse & {
    trackOriginClick: VoidFunction;
  }
> = ({recommendation, trackOriginClick}) => {
  const trackFeature = useTrackFeature();

  useEffect(() => {
    if (!recommendation || !recommendation?.products.length) {
      trackFeature({
        eventType: 'impression',
        label: 'A2B_bottomsheet_no_recos',
      });
    }
  }, [recommendation]);

  const {t} = useTranslation();

  const onProductClick = () => {
    trackFeature({
      eventType: 'click',
      label: 'bottomSheet_selectItem',
    });
    trackOriginClick();
  };

  if (!recommendation?.products.length) {
    return null;
  }

  return (
    <WearWithItSliderContainer data-testid="basketRecommendations">
      <HorizontalSlider
        title={
          <HeaderWrapper>
            <Subline size="px10" weight="mediumHeavy">
              {recommendation.subline}
            </Subline>
            <Headline size="px16" weight="mediumHeavy">
              {recommendation.headline}
            </Headline>
          </HeaderWrapper>
        }
        slideCount={2}
        hideSideButtons={true}
        disableHeaderControl
      >
        {recommendation?.products?.map((tile, index) => (
          <ProductTile
            onProductTileClick={onProductClick}
            trackingData={{
              sectionIndex: index,
              recoType: 'add_to_basket_complemetary_reco',
              elements: [{type: 'product', id: tile.productId}],
            }}
            tile={tile}
            streamPosition={index}
            key={tile.productId}
            addCtaLabel={t('Add to basket')}
          />
        ))}
      </HorizontalSlider>
    </WearWithItSliderContainer>
  );
};

const WearWithItSliderContainer = styled.div`
  overflow: hidden;
  max-width: 100%;
  border-top: 1px solid ${COLORS['Outline.Grey']};
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  flex: 1;
`;

const Headline = styled(Text)`
  line-height: 1.25;
`;

const Subline = styled(Text)`
  line-height: 1.6;
  color: ${COLORS.Grey1};
  text-transform: uppercase;
`;
